import { GET_CURRENCY_FAILD, GET_CURRENCY_LOADING, GET_CURRENCY_REMOVE, GET_CURRENCY_SUCCESS } from "../types";

const initialState = {
  loading: false,
  error: null,
  currencyList: null,
};

export const getListOfCurrency = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_CURRENCY_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_CURRENCY_SUCCESS:
      return {
        ...state,
        loading: false,
        currencyList: action.payload,
        error: null,
      };
    case GET_CURRENCY_FAILD:
      return {
        ...state,
        loading: false,
        currencyList: null,
        error: action.error,
      };
    case GET_CURRENCY_REMOVE:
      return initialState;
    default:
      return state;
  }
};
